import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-comment",
  "use": "icon-comment-usage",
  "viewBox": "0 0 1075 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1075 1024\" id=\"icon-comment\"><defs><style type=\"text/css\"></style></defs><path d=\"M1027.471325 483.425566l-182.270177 179.403006 46.284337 259.171808c5.375946 31.99968-7.372726 64.767352-28.466915 80.127199-26.930931 28.313317-67.071329 25.804542-93.336667 11.263887l-228.810512-118.731613-229.373706 118.270818c-25.599744 14.079859-68.863311 15.871841-89.599104-6.707133a88.01192 88.01192 0 0 1-32.870071-84.786352l47.615524-258.608614-182.474976-178.07182A88.319117 88.319117 0 0 1 33.279667 397.256827c9.471905-31.436486 35.634844-54.783452 66.354537-59.493805l252.515874-48.434715L465.300947 48.844312A84.069559 84.069559 0 0 1 540.97379 0c32.511675 0 61.900181 19.199808 75.570445 48.895511l113.150868 240.330397 251.287087 46.591534a84.837552 84.837552 0 0 1 67.685723 59.545004 88.575114 88.575114 0 0 1-21.196588 88.06312z\" fill=\"#bfcbd9\" p-id=\"1996\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/comment.svg
// module id = SdtW
// module chunks = 81